var React = require('react');

function TerminalInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.09098 33.9235C6.34098 33.9235 5.69052 33.648 5.13961 33.0971C4.58869 32.5462 4.31323 31.8958 4.31323 31.1458V10.0346C4.31323 9.28459 4.58869 8.63413 5.13961 8.08321C5.69052 7.53229 6.34098 7.25684 7.09098 7.25684H34.8688C35.6188 7.25684 36.2693 7.53229 36.8202 8.08321C37.3711 8.63413 37.6466 9.28459 37.6466 10.0346V31.1458C37.6466 31.8958 37.3711 32.5462 36.8202 33.0971C36.2693 33.648 35.6188 33.9235 34.8688 33.9235H7.09098ZM7.09098 31.1458H34.8688V13.479H7.09098V31.1458ZM13.4799 28.5902L11.5355 26.6457L15.8272 22.3124L11.4938 17.979L13.4799 16.0346L19.7577 22.3124L13.4799 28.5902ZM21.2577 28.7013V25.9235H30.7021V28.7013H21.2577Z","fill":"#0066FF"}));
}

TerminalInline.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = TerminalInline;

TerminalInline.default = TerminalInline;
